import { Font, Text } from "@react-pdf/renderer";
import NotoSansArabicFont from "@fontsource/noto-sans-arabic/files/noto-sans-arabic-arabic-400-normal.woff";
import { splitPdfBidiSegments } from "./paymentProofPdfTextUtils";

let fontsRegistered = false;

export const registerPaymentProofPdfFonts = () => {
  if (fontsRegistered) {
    return;
  }
  Font.register({
    family: "NotoSansArabic",
    src: NotoSansArabicFont,
  });
  fontsRegistered = true;
};

export const PaymentProofMixedText = ({
  text,
  wrapperStyle,
  arabicStyle,
  latinStyle,
}) => {
  const segments = splitPdfBidiSegments(text);
  if (!segments.length) {
    return null;
  }

  if (segments.length === 1) {
    const [segment] = segments;
    return (
      <Text style={[wrapperStyle, segment.isLatin ? latinStyle : arabicStyle]}>
        {segment.text}
      </Text>
    );
  }

  return (
    <Text style={wrapperStyle}>
      {segments.map((segment, index) => (
        <Text
          key={`${index}-${segment.text.slice(0, 12)}`}
          style={segment.isLatin ? latinStyle : arabicStyle}
        >
          {segment.text}
        </Text>
      ))}
    </Text>
  );
};
